<template>
    <div class="event__add">
        <div class="event__add_header">
            <view-actions
                :title="$t('ebs.events.add.title.newEvent')"
                :notify-title="$t('ebs.events.add.title.event')"
                :notify-process="$t('ebs.events.add.buttons.cancelAdd')"
                :cancel-button-text="$t('ebs.events.add.buttons.cancel')"
                :submit-button-active="false"
                @emit-notify-cancel-submit="eventStopAdd"
            />
        </div>
        <div class="event__add_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: $t('ebs.events.add.labels.details'), name: 'ebs-event-add-details' },
                            { label: $t('ebs.events.add.labels.sessions'), name: 'ebs-event-add-sessions' },
                            { label: $t('ebs.events.add.labels.bookings'), name: 'ebs-event-add-bookings' },
                            { label: $t('ebs.events.add.labels.cancellations'), name: 'ebs-event-add-cancellations' },
                            { label: $t('ebs.events.add.labels.feedback'), name: 'ebs-event-add-completions' },
                            { label: $t('ebs.events.add.labels.cost'), name: 'ebs-event-add-costs' }
                        ]"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="event__add_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  components: {
    ComponentSidebar,
    ViewActions
  },
  name: 'event-add',
  mounted () {
    this.$eventBus.$on('event-remove', this.eventRemove)
  },
  beforeDestroy () {
    this.$eventBus.$off('event-remove')
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('event-submit')
    },
    //
    eventStopAdd: function () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-event-list' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/events/eventaddedit";
</style>
